<template>
	<div class="p4 xs-right">
		<j-base-select :options="templates" v-model="selectedTemplate" />
		<j-button class="mt4" :isLoading="isDownloadLoading" @click="downloadPdf">{{
			$t("download")
		}}</j-button>
	</div>
</template>

<script>
import JButton from "@/components/JButton/"
import JBaseSelect from "@/components/JBaseSelect"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JButton,
		JBaseSelect
	},

	data() {
		return {
			templates: [],
			selectedTemplate: null,
			isDownloadLoading: false,
			templatesToDisplay: [
				"5d14bd06-a9f0-4cce-b4eb-a197afa08508",
				"298de5a5-02fb-4a2e-b8df-f7616f156b24",
				"2f66858b-ea33-4477-8e18-6cecfdc8b0b6",
				"6ff23313-4769-41c7-b807-6f27c8bdc486",
				"f686242c-a054-498a-9788-18dba77f9cd7",
				"16eb461e-d54c-45cd-b7f3-038780bafe91"
			]
		}
	},

	methods: {
		async downloadPdf() {
			// Query
			const query = gql`
				query renderPdfDrawingTemplate(
					$templateId: String!
					$input: templateRenderParametersInput
				) {
					renderPdfDrawingTemplate(templateId: $templateId, input: $input) {
						errors
						status
						value
					}
				}
			`

			// Variables
			const variables = {
				templateId: this.selectedTemplate,
				input: {
					name: "data",
					variablesJsonString: `{"caseWhere1":{"id":"${this.$route.params.id}"}}`
				}
			}

			// Call
			this.isDownloadLoading = true
			const res = await api({ query, variables })
			this.isDownloadLoading = false

			if (
				res.data?.renderPdfDrawingTemplate?.errors &&
				res.data?.renderPdfDrawingTemplate?.errors?.length
			) {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors?.toString() ||
							res.data?.renderPdfDrawingTemplate?.errors
					}
				})
			}

			if (res.data?.renderPdfDrawingTemplate?.status === "success") {
				let bytes = new Uint8Array(res.data?.renderPdfDrawingTemplate?.value) // pass your byte response to this constructor
				let blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
				let link = document.createElement("a")
				link.href = window.URL.createObjectURL(blob)
				link.download = "test.pdf"
				link.click()

				this.$emit("file:downloaded")
			}
		},

		async fetchTemplates() {
			const query = gql`
				query fetchTemplates($where: templateWhereInput) {
					templates(where: $where) {
						list {
							id
							name
						}
					}
				}
			`

			const variables = {
				where: {
					type: "pdfDrawing",
					id_in: this.templatesToDisplay
				}
			}

			const res = await api({ query, variables })

			this.templates = res?.data?.templates?.list?.map(item => ({
				name: item?.name,
				value: item?.id
			}))
		}
	},

	created() {
		this.fetchTemplates()
	}
}
</script>
